import Section1 from "../Finaloptical/Section1";
import Section2 from "../Finaloptical/Section2";
import Section3 from "../Finaloptical/Section3";
import Section4 from "../Finaloptical/Section4";
import Section5 from "../Finaloptical/Section5";
import Section6 from "../Finaloptical/Section6";
import Section7 from "../Finaloptical/Section7";

function Home() {
  return (
    <>
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Section7 />
    </>
  );
}

export default Home;
